module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("How to Use This Study Guide")]), _vm._v(" "), _c('p', {
    staticClass: "dingbat",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/4114_leaf.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_vm._v("Publishing a book can feel a lot like preparing a meal without knowing precisely who or how many people will show up, what will bring them or if they will like the food when they taste it. You spend one or two years cooking, likely with a particular kind of guest in mind, trying to be faithful to the ingredients, your tools, your vision and your work. You set the table and send out invitations, and on the day the banquet is ready—release day—you open wide your doors and wait. It’s only when the guests start arriving that you begin to get a sense of what they think about what you prepared. You talk to them about the meal and listen to them discuss it with each other. Trust us when we say that the conversation makes it all worthwhile. In fact, it can be thrilling!")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("When "), _c('i', {
    staticClass: "Italic"
  }, [_vm._v("Slow Church")]), _vm._v(" was first released, we really didn’t know what to expect. What happened next has been humbling and surprising and delightful. "), _c('i', {
    staticClass: "Italic"
  }, [_vm._v("Slow Church")]), _vm._v(" has ended up in college classrooms and on the required reading list of major seminaries. It’s been published in the United Kingdom and Australia, and there is now a Korean-language version. We’ve shared the stage with the leadership of Slow Food and Slow Money, and talked about Slow Church at conferences and in churches, living rooms and backyards around North America. A number of early articles and reviews speculated about a “Slow Church Movement,” but our goal has never been to build a movement, only to foster a conversation. However, we see that something is stirring in the church as communities of Jesus followers long to be more faithfully rooted in the place and pace of their neighborhoods.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Much of the Slow Church conversation is happening in small groups, which is fitting. We hope this study guide fulfills the numerous requests we have received for an expanded version of the discussion questions included in the book. Although you should feel free to adapt the guide to fit your own context, here are some recommendations for the components of each session.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_3"
    }
  }, [_vm._v("Reading")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("This is the reading that all participants will do prior to gathering. Most sessions, this will be only one chapter from the book, although the first and last sessions also include the foreword, introduction and conclusion.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_vm._v("Facilitator Prep")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("For facilitators who want to do some additional preparation (less than an hour per session), we have included several types of resources, including videos and TED Talks, audio recordings and some articles. These should be useful in providing additional context for the material in the book; you might even find some of them worth sharing with your group. We encourage you to pick and choose.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("You can find links to these resources on a single landing page on the Slow Church website at "), _c('a', {
    attrs: {
      "href": "http://guide.slowchurch.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("guide.slowchurch.com")])]), _vm._v(". We’ll continue to add more as they become available, and if you come across new resources you think will be helpful for other facilitators, let us know!")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("Welcome")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Suggested time: 10 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Start your time together with some centering practices, giving every­one a chance to arrive in both body and spirit. This is also a conscious reminder that the goal of the discussion group isn’t to get something done as efficiently as possible. The goal is to be present with one another, with God and with our neighbors.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Sit in silence for a few minutes and open with a word of prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Then listen to a song or read a poem. We’ve included the names and titles of some of our favorites. You’ll find links to many of them on our website.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_6"
    }
  }, [_vm._v("Lectio Divina")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Suggested time: 15 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Lectio divina is a centuries-old Christian practice of reading, praying and reflecting on Scripture, often in the context of community. Chris calls it “Slow Reading.” As Chris explains in his new book "), _c('i', {
    staticClass: "Italic"
  }, [_vm._v("Reading for the Common Good")]), _vm._v(", lectio divina is a kind of school where we learn to hear Christ and the word of God, and learn to devote our whole selves to Christ as part of the people of God.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Don’t be intimidated by the Latin or its ancient roots. Lectio is as important and relevant as ever, and it’s easy to do. The Scripture passage provided will be read three times at a gentle and unhurried pace, preferably by different participants. After the text is read, pause for at least a minute and then ask the following focus questions:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "li"
  }, [_vm._v("First reading: What is one word or phrase that touched my heart?")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Second reading: Where does that one word or phrase touch my life today?")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Third reading: What is the text calling "), _c('i', {
    staticClass: "Italic"
  }, [_vm._v("me")]), _vm._v(" to do or become today? What is the text calling "), _c('i', {
    staticClass: "Italic"
  }, [_vm._v("us")]), _vm._v(" to do or become?")])]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_7"
    }
  }, [_vm._v("Conversation Starters")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Suggested time: 60 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This study guide includes an expanded list of questions to help keep the conversation going. In our experience, you probably won’t need them all since participants will be bringing their own questions and reflections. Although the questions are presented in a sequence that makes sense to us, don’t rush to get through them. The discussion will go places no one can predict . . . and that’s a good thing!")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We suggest beginning the first session by collectively identifying the characteristics of good conversation: vulnerability, confidentiality, listening, assuming the best of each other and so on. Then task someone to craft a set of “agreements” for participants to make with one another. For example, John’s church has developed a list of thirteen agreements as they have embraced conversation as a formative practice. The full list is available on our website ("), _c('a', {
    attrs: {
      "href": "http://guide.slowchurch.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("guide.slowchurch.com")])]), _vm._v("), but it includes the following:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "li"
  }, [_vm._v("We will acknowledge Christ’s presence among us and in each one of us.")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("We will practice reconciliation.")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("We will not be afraid of silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("These agreements are often read out loud, and they are always open to revision.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Finally, find ways to encourage the participation of everyone—including introverts or people who are more deliberate in their processing—by inviting input from folks who haven’t had the opportunity to share. It’s also wise to consider the difference between reacting and responding. Some groups do this by incorporating pauses and “pulse checks”: ask participants to pause for five seconds between comments. Not only does this slow the pace of the discussion but it also gives everyone a chance to process (and honor) what has just been said.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_8"
    }
  }, [_vm._v("Closing Thought")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Suggested time: 5 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We have included a final quote as a way of closing your time together. While this can be used to spark one final point of discussion, we envision it as a parting thought for participants to take with them for reflection in the coming week.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Would you mind keeping in touch? We would love to hear about the Slow Church conversations that are happening in your communities. (Actually, we’d even love to pop in via Skype or Google Hangouts to say hello to your group!) We also welcome your suggestions, so we’ve included both of our personal email addresses below.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("More people from more places have come to the Slow Church banquet than we expected. But there is also a sense that the feast is just getting started. In fact, it’s turning into a potluck; every new guest is bringing something unique to the table. The two of us are learning so much from you. Thank you!")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('i', {
    staticClass: "Italic"
  }, [_vm._v("Chris and John")])]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_9"
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("C. Christopher Smith: "), _c('a', {
    attrs: {
      "href": "mailto:englewoodreview%40gmail.com?subject="
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("englewoodreview@gmail.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("John Pattison: "), _c('a', {
    attrs: {
      "href": "mailto:johnepattison%40gmail.com?subject="
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("johnepattison@gmail.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Twitter: "), _c('a', {
    attrs: {
      "href": "https://twitter.com/SlowChurches",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("@SlowChurches")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "http://guide.slowchurch.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlinks"
  }, [_vm._v("guide.slowchurch.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96ceb248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/howtouse.vue
// module id = 63
// module chunks = 0